'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _slide = require('./slide');

var _slide2 = _interopRequireDefault(_slide);

var _fade = require('./fade');

var _fade2 = _interopRequireDefault(_fade);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A sliding fade transition.
 *
 * @public
 * @property {Array} in
 *   Fades in
 * @property {Array} in.normal
 *   Transition from left to right
 * @property {Array} in.reverse
 *   Transition from right to left
 * @property {Array} in.up
 *   Transition upwards
 * @property {Array} in.down
 *   Transition downwards
 * @property {Array} out
 *   Fades out
 * @property {Array} out.normal
 *   Transition from left to right
 * @property {Array} out.reverse
 *   Transition from right to left
 * @property {Array} out.up
 *   Transition upwards
 * @property {Array} out.down
 *   Transition downwards
 */
var fadeSlide = {
  in: {
    normal: (0, _styledComponents.css)(['--direction:1;--regulator:0;', ';', ';'], _fade2.default.in, _slide2.default.normal),
    reverse: (0, _styledComponents.css)(['--direction:1;--regulator:0;', ';', ';'], _fade2.default.in, _slide2.default.reverse),
    up: (0, _styledComponents.css)(['', ';', ';'], _fade2.default.in, _slide2.default.up),
    down: (0, _styledComponents.css)(['', ';', ';'], _fade2.default.in, _slide2.default.down)
  },
  out: {
    normal: (0, _styledComponents.css)(['--direction:1;--regulator:1;', ';', ';'], _fade2.default.out, _slide2.default.normal),
    reverse: (0, _styledComponents.css)(['--direction:1;--regulator:1;', ';', ';'], _fade2.default.out, _slide2.default.reverse),
    up: (0, _styledComponents.css)(['--direction:-1;--regulator:1;', ';', ';'], _fade2.default.out, _slide2.default.up),
    down: (0, _styledComponents.css)(['--direction:-1;--regulator:1;', ';', ';'], _fade2.default.out, _slide2.default.down)
  }
};

exports.default = fadeSlide;
//# sourceMappingURL=fade-slide.js.map